module.exports = __webpack_public_path__ + "static/media/deck-5-right.c99075d1.png";